import React, { useEffect, useRef, useState } from "react"
import { Alert } from "reactstrap"
import { instantLabel } from "./plannerLabels"
import { UNCONFIRMED } from "./proposalMessages"
import { failedLine, sendingMessage } from "./sendingLabels"
import AddressPicker, { addressesChanged, addressesReady, initialAddresses, recipientsOf } from "./AddressPicker"
import PlannerDialog from "./PlannerDialog"

// "Email failed" (ticket 16; Phase C2b): the organizer's current list sent again as it was sent — the same list, the same answer-by day —
// by email to the addresses checked again, or recorded as delivered by the SuperAdmin outside the platform. Nothing of the proposals
// changes. A refusal is shown here.
export default function ResendDialog({ entry, list, name, timeZone, commands, onClose }) {
  const [how, setHow] = useState(list?.team?.email ? "email" : "outsidePlatform")
  const [address, setAddress] = useState(() => initialAddresses(list?.organizer))
  const [state, setState] = useState({})
  const open = useRef(true)
  useEffect(() => () => { open.current = false }, [])
  const sending = entry.lastSending
  const resend = async () => {
    setState({ pending: true })
    const result = await commands.resend({ sendingId: sending.sendingId, how, ...(how === "email" && { recipients: recipientsOf(address), addressChecked: true }) },
      { name, how })
    if (!open.current) return
    if (result?.status === "saved") return onClose()
    setState({ error: result?.status === "unknown" ? result.message || UNCONFIRMED : sendingMessage(result?.code, result?.details) })
  }
  return <PlannerDialog title={`Send the list of ${instantLabel(sending.at, timeZone)} again?`} sub={`${name} · the same list, with the same answer-by day`}
    dirty={how === "email" && addressesChanged(address, list?.organizer)} onClose={onClose}
    actions={<button type="button" className="btn btn-primary" disabled={state.pending || (how === "email" && !addressesReady(address))}
      title={how === "email" && !addressesReady(address) ? "Choose the addresses and tick “I checked…” first." : undefined} onClick={resend}>
      {how === "email" ? "Send the email again" : "Record that I sent it"}</button>}>
    <p className="mb-0">{failedLine(sending, timeZone)}</p>
    <span className="ep-segment" role="group" aria-label="How it goes again">
      <button type="button" aria-pressed={how === "email"} className={"ep-chip" + (how === "email" ? " is-on" : "")} disabled={!list?.team?.email}
        onClick={() => setHow("email")}>By email</button>
      <button type="button" aria-pressed={how === "outsidePlatform"} className={"ep-chip" + (how === "outsidePlatform" ? " is-on" : "")}
        onClick={() => setHow("outsidePlatform")}>I sent it myself</button>
    </span>
    {how === "email" ? <AddressPicker id="ep-resend" value={address} team={list?.team} onChange={setAddress} />
      : <p className="ep-meta mb-0">The list is recorded as delivered by you outside the platform (WhatsApp, your own email, the phone).</p>}
    {state.error && <Alert color="danger" className="mb-0">{state.error}</Alert>}
  </PlannerDialog>
}
